import { render } from "./TrainingProgramSheetComponent.vue?vue&type=template&id=474c444c&scoped=true"
import script from "./TrainingProgramSheetComponent.vue?vue&type=script&lang=js"
export * from "./TrainingProgramSheetComponent.vue?vue&type=script&lang=js"

import "./TrainingProgramSheetComponent.vue?vue&type=style&index=0&id=474c444c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-474c444c"]])

export default __exports__